import { render, staticRenderFns } from "./OrderableShippingMethod.vue?vue&type=template&id=92cd4b30&"
import script from "./OrderableShippingMethod.vue?vue&type=script&lang=ts&"
export * from "./OrderableShippingMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports